/**
 * Progressivity Mapper
 * Maps backend transport types to domain models
 */

import type { LC_ProgressivityItemOut, Progressivity } from '../types';
import { formatToDdMmYyyy } from '@/utils';


export function mapProgressivityItem(item: LC_ProgressivityItemOut): Progressivity {
  return {
    rawStartDate: item.startDate,
    startDate: formatToDdMmYyyy(item.startDate),
    weeklyHours: item.weeklyHours,
    createdAt: formatToDdMmYyyy(item.createdAt),
    createdBy: item.createdBy ?? null,
  };
}


